import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
// eslint-disable-next-line no-restricted-imports
import Vuex from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vuex.js?vue3';
import * as actions from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ref/stores/actions.js?vue3';
import * as getters from './getters';
import mutations from './mutations';
import createState from './state';

Vue.use(Vuex);

export default () =>
  new Vuex.Store({
    actions,
    getters,
    mutations,
    state: createState(),
  });

export const createRefModule = () => ({
  namespaced: true,
  actions,
  getters,
  mutations,
  state: createState(),
});
